import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Icon from "@material-ui/core/Icon";
import tigerLogo from "images/tree/tiger.png";
import { observer } from "mobx-react";

const getIcon = (iconClasses) => {
  if (iconClasses) {
    return <Icon className={"menu_item_icon " + iconClasses} />;
  }
  return <img className="tiger_logo" src={tigerLogo} />;
};

const Packs = ({ packs, currentPackId, onClick }) =>
  packs.map((pack, id) => (
    <MenuItem
      className={
        "packs_list_item " +
        (currentPackId ? (currentPackId == pack.id ? " selected" : "") : "")
      }
      key={id}
      onClick={() => onClick(pack)}
    >
      {getIcon(pack.icon)}
      {pack.name}
    </MenuItem>
  ));

export default observer(Packs);
